import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListPermissionsUseCase({ membershipRepository }: Deps) {
  return async function listPermissions(orgId: string): Promise<PermissionEntity[]> {
    return membershipRepository.listPermissions(orgId);
  };
}
